.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: -2px 0 4px;
}

.header {
  margin: 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 6px;
  background: var(--color-muted-background, #f9fafb);
}

.info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  display: flex;
  align-items: center;
  gap: 6px;
}

// The existing ticket's reference (T-140), so a reporter who recognises their
// issue in this list has a number to quote.
.ref {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.vote {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 4px 8px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 999px;
  background: transparent;
  color: var(--color-muted, #6b7280);
  font-size: 12px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.vote-active {
  color: var(--color-primary, #2563eb);
  border-color: var(--color-primary, #2563eb);
}

.vote-icon {
  height: 14px;
  width: 14px;
}
